module.exports = __webpack_public_path__ + "img/manage_accounts@3x.28803936.png";